document.addEventListener("DOMContentLoaded", () => {
  function addHandleForRecentProductsFetch() {
    const productElement = document.querySelector(".js-product");

    if (!productElement?.dataset.productHandle) return;

    let handles = null;
    const productHandle = productElement.dataset.productHandle;

    try {
      handles = localStorage.getItem("recently-viewed");
    } catch (_error) {
      return;
    }

    if (handles) {
      if (handles.includes(productHandle)) return;

      const handlesToAdd = [productHandle, ...handles.split(",")];

      if (handlesToAdd.length > 10) {
        handlesToAdd.pop();
      }

      try {
        localStorage.setItem("recently-viewed", handlesToAdd.join(","));
      } catch (_error) {
        return;
      }

      return;
    }

    try {
      localStorage.setItem("recently-viewed", productHandle);
    } catch (_error) {
      return;
    }
  }
  addHandleForRecentProductsFetch();
});
